export enum Policy {
	ViSyAdmins,
	ViSyUser,
	CustomerAdmins,
	UserSecurityLevel_1,
	UserSecurityLevel_2,
	UserSecurityLevel_3,
	AllUsers
}